module.exports = __webpack_public_path__ + "img/full7-min.be7ee6a3.png";